import { resolvePath, useLocation, useRouteError } from 'react-router';

import { Navigate } from '../Navigate';
import { isNotFoundError } from '../isNotFoundError';

export const RedirectToParent = () => {
  const location = useLocation();

  return (
    <Navigate
      to={resolvePath('..', location.pathname).pathname}
      keepSearchParams
      replace
    />
  );
};

export const RedirectToParentOnNotFound = () => {
  const routeError = useRouteError();
  if (isNotFoundError(routeError)) {
    return <RedirectToParent />;
  }
  throw routeError;
};
